<div class="contact-body-detail">
    <div class="screen-loading-spin" loading-spin [isLoading]="!isDataPrepare" [loadingSize]="'big'"
        *ngIf="!isDataPrepare">
    </div>
    <div class="body-container" [style.overflow-y]="windowSize>=838?'hidden':'auto'" *ngIf="isDataPrepare">
        <div [ngClass]="{'contact-information': windowSize>=833, 'min-contact-information':windowSize<833}"
            *ngIf="windowSize>=833 || isContactProfileHasData">
            <tam-contact-profile [config]="contactInformation" [triggerSource]="triggerSource"></tam-contact-profile>
        </div>
        <div [ngClass]="{'contact-container-right': windowSize>=695, 'min-contact-container-right':windowSize<695}">
            <div class="contact-relationship-note">
                <div
                    [ngClass]="{'contact-relationship': windowSize>=695, 'min-contact-relationship':windowSize<695, 'contact-relationship-collapse': isPosition1Collapse}">
                    <tam-contact-detail-template [config]="configForPageComponent[0]"></tam-contact-detail-template>
                </div>
                <div
                    [ngClass]="{'contact-note': windowSize>=695, 'min-contact-note':windowSize<695, 'contact-note-collapse': isPosition1Collapse}">
                    <tam-contact-detail-template [config]="configForPageComponent[1]"></tam-contact-detail-template>
                </div>
            </div>
            <div class="contact-activity-address">
                <div
                    [ngClass]="{'contact-activity': windowSize>=695, 'min-contact-activity':windowSize<695, 'contact-activity-collapse': isPosition3Collapse}">
                    <tam-contact-detail-template [config]="configForPageComponent[2]"
                        #child></tam-contact-detail-template>
                </div>
                <div
                    [ngClass]="{'contact-address': windowSize>=695, 'min-contact-address':windowSize<695, 'contact-address-collapse': isPosition3Collapse}">
                    <tam-contact-detail-template [config]="configForPageComponent[3]"></tam-contact-detail-template>
                </div>
            </div>
        </div>
    </div>
</div>